



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Vehicle } from '../../models';
import { Method } from '../../utils';

@Component
export default class SelectedVehicle extends Vue {
    @Prop() vehicle: Vehicle;
    @Prop() input: Method<Vehicle, void>;
    @Prop({ default: false }) isMock: boolean;

    get getVehicle() {
        if (this.vehicle !== undefined && this.vehicle.vehicle_plate !== undefined) {
            let vehiclePlate = this.vehicle.vehicle_plate;
            let vehDescription = this.vehicle.description;
            if (vehDescription !== vehiclePlate) {
                return vehDescription + ' - ' + vehiclePlate;
            } else {
                return vehDescription;
            }
        } else {
            return this.vehicle;
        }
    }

    handleInput(vehicle: Vehicle) {
        if (!this.isMock) {
            this.input(vehicle);
        }
    }
}
